const galleryId = 111;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_1302070210.jpg","sh_1311646574.jpg","sh_1498595687.jpg","sh_782196931.jpg","sh_1741090847.jpg","sh_1266839704.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Underbite'));

group = ["sh_1444882235.jpg","sh_1542434444.jpg","sh_1524366149.jpg","sh_1473956036.jpg","sh_1708644454.jpg","sh_1197733597.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Overbite'));

export default items;
